var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "876px",
    height: "876px",
    viewBox: "0 0 876 876",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cloud1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cloud1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263,242 C262.863277,230.578103 256.986191,220.386411 248.469455,217.940005 C247.124182,217.55294 245.781903,217.386913 244.461579,217.409917 C241.688201,207.682301 235.49775,199.995025 227.473016,197.688642 C219.268647,195.33125 211.176052,199.178889 205.787974,206.896171 C204.178237,205.643963 202.404832,204.703807 200.497698,204.155716 C191.980962,201.708309 183.187786,212.163045 188.734543,220.660456 L263,242",
    id: "Fill-20",
    fill: "#FFFCFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud1);
export default __webpack_public_path__ + "static/media/Cloud1.7c93799eb296ec40c925711eb9f36fc7.svg";
export { ForwardRef as ReactComponent };